import apiRequestService from '@/commonProject/service/apiRequestService';

export default class setupCompanyRepository {
    /**
     * ユーザー企業PW確認APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async checkUserCompanyPasswordActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrcmppwd', requestBody, idToken);
        return result;
    }
}
